import type { RelatedCode } from '@/features/factsheet';
import RelatedCodeItem from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/RelatedCodesTab/RelatedCodeItem';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';
import { cn } from '@/lib/utils';

const RelatedCodeList = ({
  title,
  relatedCodes,
  openNewTab
}: {
  title: string;
  relatedCodes: RelatedCode[] | undefined;
  openNewTab: (code: string) => void;
}) => {
  const isCompact = useIsFactsheetCompact();
  return (
    <div>
      <p className={cn('pb-1 font-bold', isCompact && 'text-sm')}>{title}</p>
      {relatedCodes?.length === 0 && <p className={cn('pb-1', isCompact && 'text-sm')}>None.</p>}
      {relatedCodes?.map((relatedCode, index) => (
        <RelatedCodeItem
          key={relatedCode.code + index}
          openNewTab={openNewTab}
          relatedCode={relatedCode}
        />
      ))}
    </div>
  );
};

export default RelatedCodeList;
